import { Activity } from '../types';
import _get from 'lodash/get';

export default ({
  activity_id: activityId,
  categories,
  charge_per: type,
  charge_type: chargeType,
  cover_photo: { original: coverPhoto },
  day_part_availability: dayPartAvailability,
  default_price: defaultPrice,
  discount,
  duration_minutes: durationMinutes,
  favorite,
  locality_id: localityId,
  min_amount_parts: minAmountParts,
  // eslint-disable-next-line camelcase
  rating_info,
  title,
  without_discount: withoutDiscount,
}: any): Activity => {
  const rating = {
    // eslint-disable-next-line camelcase
    value: rating_info.value,
    // eslint-disable-next-line camelcase
    text: rating_info.text,
    // eslint-disable-next-line camelcase
    marksCount: rating_info.marks_count,
    // eslint-disable-next-line camelcase
    reviewsCount: rating_info.reviews_count,
  };

  return {
    activityId,
    categories,
    chargeType,
    coverPhoto,
    dayPartAvailability,
    discount,
    durationMinutes,
    favorite,
    localityId,
    minAmountParts,
    price: _get(defaultPrice, 'RUB'),
    rating,
    title,
    type,
    withoutDiscount,
  };
};
